import { useState } from "react";
import { FiX, FiPlus, FiTrash2 } from "react-icons/fi";
import { useTranslation } from "../context/TranslationContext";

const QuestionsModal = ({ isOpen, setIsOpen, questions = [], onSave, isDark, setToast }) => {
  const { t } = useTranslation();
  const [localQuestions, setLocalQuestions] = useState(questions || []);

  const baseText = "text-label-primary";
  const mutedText = "text-label-secondary";
  const cardBase = isDark
    ? "border-white/15 bg-black"
    : "border-slate-200 bg-white";
  const inputBase = "border-transparent bg-fill-tertiary text-label-primary placeholder:text-label-tertiary focus:ring-2 focus:ring-focus-ring";

  const handleAddQuestion = () => {
    if (localQuestions.length >= 10) {
      setToast(t("mintSpace.maxQuestions"));
      return;
    }
    setLocalQuestions([...localQuestions, ""]);
  };

  const handleRemoveQuestion = (index) => {
    setLocalQuestions(localQuestions.filter((_, i) => i !== index));
  };

  const handleQuestionChange = (index, value) => {
    const updated = [...localQuestions];
    updated[index] = value;
    setLocalQuestions(updated);
  };

  const handleSave = () => {
    // Filter out empty questions
    const validQuestions = localQuestions.filter((q) => q.trim() !== "");
    onSave(validQuestions);
    setIsOpen(false);
  };

  const handleSkip = () => {
    onSave([]);
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[10000] flex items-end justify-center bg-overlay-scrim min-[600px]:items-center min-[600px]:p-4"
      onClick={() => setIsOpen(false)}
    >
      <div
        className={`relative w-full max-w-2xl rounded-t-radius-xl border p-space-24 shadow-overlay min-[600px]:rounded-radius-lg ${cardBase}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-4 flex items-center justify-between">
          <div>
            <h3 className={`text-title-3 ${baseText}`}>Add Join Questions</h3>
            <p className={`text-subheadline mt-1 ${mutedText}`}>
              Add up to 10 questions that users must answer to join your mint space. Leave empty to allow free joining.
            </p>
          </div>
          <button
            onClick={() => setIsOpen(false)}
            className={`rounded-radius-sm p-2 transition hover:bg-fill-quaternary`}
          >
            <FiX className={`h-5 w-5 ${mutedText}`} />
          </button>
        </div>

        <div className="space-y-3 max-h-96 overflow-y-auto mb-4">
          {localQuestions.length === 0 ? (
            <p className={`text-subheadline text-center py-8 ${mutedText}`}>
              No questions added. Users can join freely.
            </p>
          ) : (
            localQuestions.map((question, index) => (
              <div key={index} className="flex items-start gap-2">
                <div className="flex-1">
                  <input
                    type="text"
                    value={question}
                    onChange={(e) => handleQuestionChange(index, e.target.value)}
                    placeholder={`Question ${index + 1}`}
                    className={`w-full px-4 py-2 rounded-radius-sm border transition ${inputBase}`}
                  />
                </div>
                <button
                  onClick={() => handleRemoveQuestion(index)}
                  className={`p-2 rounded-radius-xs transition hover:bg-fill-quaternary text-status-danger`}
                >
                  <FiTrash2 className="h-4 w-4" />
                </button>
              </div>
            ))
          )}
        </div>

        <div className="flex items-center justify-between pt-4 border-t border-white/10">
          <button
            onClick={handleAddQuestion}
            disabled={localQuestions.length >= 10}
            className={`flex items-center gap-2 px-4 py-2 rounded-radius-sm border transition ${
              "border-separator-default bg-bg-raised hover:bg-fill-quaternary text-label-secondary"
            } disabled:opacity-50 disabled:cursor-not-allowed`}
          >
            <FiPlus className="h-4 w-4" />
            Add Question ({localQuestions.length}/10)
          </button>

          <div className="flex gap-3">
            <button
              onClick={handleSkip}
              className={`px-4 py-2 rounded-radius-sm border transition ${
                "border-separator-default bg-bg-raised hover:bg-fill-quaternary text-label-secondary"
              }`}
            >
              Skip
            </button>
            <button
              onClick={handleSave}
              className="px-4 py-2 rounded-radius-sm bg-accent-default text-accent-on font-semibold transition"
            >
              Save Questions
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionsModal;



